import { createSelector } from 'reselect';
import { getDestination } from 'store/destination/destinationSelectors';
import { DESTINATION_STATUS } from 'lib/enums/destination';

export const getDestinationPageDataLayerVariables = createSelector([getDestination], (destination) => {
  const ready = destination?.status === DESTINATION_STATUS.RESOLVED;

  return {
    ready,
    destinationName: destination?.regionName,
  };
});
